import { Logo } from "./Logo";

type WordmarkProps = {
  size?: number;
  showTagline?: boolean;
  className?: string;
};

export function Wordmark({ size = 32, showTagline = false, className }: WordmarkProps) {
  return (
    <div className={`flex items-center gap-3 ${className ?? ""}`}>
      <Logo size={size} />
      <div>
        <div
          className="font-bold text-base leading-none"
          style={{ fontFamily: "Geist, system-ui, sans-serif", color: "var(--black)" }}
        >
          Stockuj
        </div>
        {showTagline && (
          <div
            className="mt-1 uppercase"
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: "10px",
              fontWeight: 500,
              letterSpacing: "3px",
              color: "var(--gray-muted)",
            }}
          >
            Magazyn · na · autopilocie
          </div>
        )}
      </div>
    </div>
  );
}
